import { Carousel } from "antd";
import React, { useEffect } from "react";
import "./Banner.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1500,
    });
  }, []);
  function onChange(a, b, c) {}

  const contentStyle = {
    height: "500px",
    color: "#fff",
    textAlign: "center",
  };
  return (
    <div className="w-full">
      <Carousel autoplay={true} afterChange={onChange}>
        {/* slider 1 */}
        <div className="banner-1">
          <div
            style={contentStyle}
            className="banner-design pt-16 grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1"
          >
            <div
              data-aos="zoom-in-left"
              className="items-stretch lg:text-left lg:pl-32 text-center"
            >
              <h2 className="text-2xl tracking-widest text-gray-700 pb-2 pt-8 font-extrabold">
                Here at "Doctor Bari" We Offer
              </h2>
              <h1 className="text-4xl lg:text-6xl text-white font-extrabold">
                World Class Medical Treatment
              </h1>
              <hr />
              <p className="lg:text-xl">
                Your Health are important, so we’re here to provide best
                services. Find out about our all services and what happens when
                you come for an any test.
              </p>
            </div>
            <div></div>
          </div>
        </div>
        {/* slider 2 */}
        <div className="banner-2 ">
          <div
            style={contentStyle}
            className="banner-design pt-16 grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1"
          >
            <div></div>
            <div className="items-center text-center ">
              <h2 className="text-2xl tracking-widest text-gray-700 pb-2 pt-8 font-extrabold">
                Here at "Doctor Bari" We Offer
              </h2>
              <h1 className="text-4xl lg:text-6xl text-white font-extrabold">
                World Class Services
              </h1>
              <hr />
              <p className="text-sm lg:text-lg">
                We are committed to (i) Quality, (ii) Effectiveness, (iii)
                Integration, (iv) Caring for the Community, (v) Caring for our
                staff and (vi) Research & Training. Our number one priority is
                to provide our patients with high quality healthcare in a
                friendly and compassionate environment.”
              </p>
            </div>
            <div></div>
          </div>
        </div>
        {/* slider 3 */}
        <div className="banner-3 ">
          <div
            style={contentStyle}
            className="banner-design pt-16 grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1"
          >
            <div></div>
            <div className="items-stretch text-left lg:pr-32">
              <h2 className="text-2xl text-center lg:text-right tracking-widest text-gray-700 pb-2 pt-8 font-extrabold">
                Here at "Doctor Bari" We Offer
              </h2>
              <h1 className="text-4xl lg:text-6xl text-center lg:text-right text-white font-extrabold">
                About Our Clinic
              </h1>
              <hr />
              <p className="lg:text-right lg:text-xl text-center">
                Doctor Bari, providing our patients with a trusted and
                compassionate environment for healthcare is central to our
                mission. We draw strength from our purpose, which is above all
                to help and to heal.
              </p>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default Banner;
